import * as actions from './docQueue.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { DocQueueModel } from '@smarttask-common/src/lib/models/Record/Doc/Queue/DocQueueModel';

export const queueAdapter = createEntityAdapter<DocQueueModel>({
    selectId: (x) => x.id,
});
export interface DocQueueState extends EntityState<DocQueueModel> {
    selected_id: string;
}

export const initialState: DocQueueState = queueAdapter.getInitialState({
    selected_id: undefined,
});

export function DocQueueReducers(state: DocQueueState = initialState, action: actions.DocQueueActions) {
    switch (action.type) {
        case actions.DocQueueActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_id: action.selected_id };
            return state;

        case actions.DocQueueActionTypes.ADD_QUEUE:
            return queueAdapter.addOne(action.queue_item, state);

        case actions.DocQueueActionTypes.ADD_QUEUES:
            return queueAdapter.addMany(action.queue, state);

        case actions.DocQueueActionTypes.UPSERT_QUEUE:
            return queueAdapter.upsertOne(action.queue_item, state);

        case actions.DocQueueActionTypes.UPSERT_QUEUES:
            return queueAdapter.upsertMany(action.queue, state);

        case actions.DocQueueActionTypes.UPDATE_QUEUE:
            return queueAdapter.updateOne(action.queue_item, state);

        case actions.DocQueueActionTypes.UPDATE_QUEUES:
            return queueAdapter.updateMany(action.queue, state);

        case actions.DocQueueActionTypes.DELETE_QUEUE:
            return queueAdapter.removeOne(action.id, state);

        case actions.DocQueueActionTypes.DELETE_QUEUES:
            return queueAdapter.removeMany(action.ids, state);

        case actions.DocQueueActionTypes.DELETE_ALL_QUEUES:
            return queueAdapter.removeMany(action.ids, state);

        case actions.DocQueueActionTypes.DELETE_ALL:
            return queueAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getDocQueueState = createFeatureSelector<DocQueueState>('docQueue');

export const { selectIds, selectEntities, selectAll, selectTotal } = queueAdapter.getSelectors(getDocQueueState);

const getSelectedDocIdState = (state: DocQueueState) => {
    return state.selected_id;
};
export const getSelectedDocId = createSelector(getDocQueueState, getSelectedDocIdState);

export const getSelectedDoc = createSelector(getDocQueueState, (state: DocQueueState) => {
    if (state.selected_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_id];
});
